import React from 'react';

// Shown in place of a screen the signed-in admin's role or source can't use.
function NotAvailable() {
    return (
        <div className="content">
            <div className="container-fluid">
                <div className="card mb-3">
                    <div className="card-body text-center py-5">
                        <h5>Not available for this admin account.</h5>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotAvailable;
